<div class="stat">
    <span class="stat-label">{{titulo}}</span>
    <span class="stat-value">{{valor}}</span>
</div>
